import { CriteriaLibraryReadModel } from "@Criteria/Hierarchies/Domain/readmodels";

export class CriteriaLibraryViewModel
{
    opened: boolean = false;

    parentId: number | null = null;
    data: CriteriaLibraryReadModel | null = null;

    show(parentId: number)
    {
        this.parentId = parentId;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.parentId = null;
    }

    setData(data: CriteriaLibraryReadModel)
    {
        this.data = data;
    }

    setUsed(names: string[])
    {
        const templates = this.data?.CriteriaTemplates.filter(a => names.indexOf(a.Name) > -1) ?? [];
        templates.forEach(a => a.Used = true);
    }
}